import { j as e } from "../../jsx-runtime-BwWtxLpl.js";
import { useEffect as y } from "react";
import x from "focus-trap-react";
import o from "prop-types";
import h from "classnames";
import j from "./modal-portal.js";
import { ModalProvider as v } from "./modal.context.js";
const b = ({
  children: d,
  className: r = "",
  show: a = !1,
  variant: m = "default",
  onClose: i = null,
  size: t = "default",
  takeover: l = !1,
  focusTrapOptions: f = {},
  ...n
}) => {
  const s = () => {
    i(), document.body.style.overflow = "";
  }, c = h({
    "motif-modal": !0,
    "motif-modal-content": !0,
    "motif-modal-slideout": m === "slideout",
    "motif-modal-alt": m === "alt",
    "motif-modal-size-sm": !l && t === "sm",
    "motif-modal-size-md": !l && (t === "md" || t === "default"),
    "motif-modal-size-lg": !l && t === "lg",
    "motif-modal-size-xl": !l && t === "xl",
    "motif-modal-takeover": l,
    [r]: !0
  });
  y(() => {
    document.body.style.overflow = a ? "hidden" : "";
  }, [a]);
  const u = (p) => {
    switch (p.key) {
      case "Escape":
        s();
        break;
    }
  };
  return /* @__PURE__ */ e.jsx(v, { value: { closeModal: s }, children: a && /* @__PURE__ */ e.jsx(j, { children: /* @__PURE__ */ e.jsx(
    "div",
    {
      "data-testid": "motif-modal-overlay",
      className: `motif-modal-overlay ${l ? "motif-modal-overlay-takeover" : ""}`,
      "data-motif-modal": !0,
      children: /* @__PURE__ */ e.jsx(
        x,
        {
          focusTrapOptions: {
            preventScroll: !0,
            ...f
          },
          children: /* @__PURE__ */ e.jsx("div", { role: "dialog", "aria-modal": "true", className: c, onKeyDown: u, ...n, children: d })
        }
      )
    }
  ) }) });
};
b.propTypes = {
  children: o.node,
  className: o.string,
  variant: o.oneOf(["default", "alt", "slideout"]),
  show: o.bool,
  onClose: o.func,
  size: o.oneOf(["default", "sm", "md", "lg", "xl"]),
  takeover: o.bool,
  focusTrapOptions: o.objectOf(o.shape)
};
export {
  b as MotifModal
};
